import {call, put} from "redux-saga/effects";
import {getSouscriptionApi, modificationSouscriptionApi,} from "../../../../common/apis/souscriptionApi";
import * as actions from "../state/modificationSouscriptionActions";

export function* modificationSouscriptionSaga({ payload }) {
  try {
    const response = yield call(modificationSouscriptionApi, payload);
    console.log("response", response);
    yield put(
      actions.modificationSouscriptionSuccessAction(response.data.body)
    );
  } catch (error) {
    yield put(actions.modificationSouscriptionFailAction(error));
  }
}

export function* getSouscriptionToModifySaga({ payload }) {
  try {
    const response = yield call(getSouscriptionApi, payload);
    console.log(response);
    yield put(actions.getSouscriptionToModifySuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.getSouscriptionToModifyFailAction(error));
  }
}
